import React from 'react';
import { ChevronRight, Heart, Globe, Play } from 'lucide-react';
import SocialShare from './SocialShare';

export default function Hero() {
  return (
    <div id="home" className="relative min-h-screen overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1438232992991-995b7058bbb3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80"
          alt="Church gathering worship"
          className="w-full h-full object-cover scale-105"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-navy-950/80 via-navy-900/60 to-primary-900/40"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-navy-950/70 via-transparent to-transparent"></div>
      </div>

      <div className="absolute top-24 right-8 z-20 hidden md:block animate-fade-in">
        <SocialShare />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-36 pb-16 min-h-screen flex items-center">
        <div className="text-center md:text-left md:max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-md rounded-full mb-8 border border-white/10 animate-fade-in">
            <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
            <span className="text-white/90 text-sm font-medium tracking-wide">Welcome to ETWC Ministry</span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white mb-6 leading-[1.1] tracking-tight animate-fade-in-up text-balance">
            Committed to Reaching{' '}
            <span className="relative inline-block">
              <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-r from-blue-300 to-cyan-300">The Nations</span>
            </span>
          </h1>

          <p className="text-lg md:text-xl text-gray-200 mb-10 leading-relaxed animate-fade-in-up max-w-2xl" style={{ animationDelay: '0.2s' }}>
            We are a Holy Spirit-Led, evangelistic ministry laboring for souls in North America, South America, and across the world. Our mission is to share the profound message of the Gospel of Jesus Christ with the greatest impact possible.
          </p>

          <div className="flex flex-wrap items-center gap-3 mb-10 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2.5 rounded-full border border-white/10">
              <Heart size={16} className="text-red-400" />
              <span className="text-white/90 text-sm font-medium">Faith-Based Community</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2.5 rounded-full border border-white/10">
              <Globe size={16} className="text-blue-300" />
              <span className="text-white/90 text-sm font-medium">Global Evangelism</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
            <a
              href="#services"
              className="group relative bg-white text-gray-900 px-8 py-4 rounded-full hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-0.5 flex items-center justify-center font-semibold overflow-hidden"
            >
              <span className="relative z-10 flex items-center">
                Join Us Sunday
                <ChevronRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
              </span>
            </a>
            <a
              href="https://www.youtube.com/@clevelandstreetpreachers"
              target="_blank"
              rel="noopener noreferrer"
              className="group border-2 border-white/30 text-white px-8 py-4 rounded-full hover:bg-white/10 hover:border-white/50 transition-all duration-300 text-center font-semibold flex items-center justify-center gap-2 transform hover:-translate-y-0.5"
            >
              <Play size={18} className="fill-current" />
              Watch Online
            </a>
          </div>

          <div className="mt-10 md:hidden animate-fade-in" style={{ animationDelay: '0.5s' }}>
            <SocialShare className="justify-center flex" />
          </div>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2">
        <a href="#about" className="flex flex-col items-center gap-2 text-white/60 hover:text-white/90 transition-colors" aria-label="Scroll to content">
          <span className="text-xs font-medium tracking-widest uppercase">Explore</span>
          <ChevronRight size={20} className="transform rotate-90 animate-bounce" />
        </a>
      </div>
    </div>
  );
}
